var Theme = {};

const BREAKPOINT_LARGEDESKTOP   = 1800;
const BREAKPOINT_MEDIUMDESKTOP  = 1500;
const BREAKPOINT_DESKTOP        = 1360;
const BREAKPOINT_LAPTOP         = 1200;
const BREAKPOINT_TABLETHOR      = 1024;
const BREAKPOINT_TABLET         = 768;
const BREAKPOINT_PHABLET        = 576;
const BREAKPOINT_MOBILE         = 325;

(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.Theme = {};

  /**
   * Constructeur
   */
  Theme.Common = function () {
    // Éléments
    this.elements = {
      htmlBody: $('html, body'),
      body: $('body'),
      page: $('#page'),
    };

    this.elements.externalLinks = this.elements.page.find('a[href^="http"]');
    this.elements.openInNewWindowLinks = this.elements.page.find('a[href$=".pdf"]');

    // Variables
    this.menuScrollOffset = 110;
    this.langcode = drupalSettings.path.currentLanguage || 'fr';

    return this;
  };

  /**
   * Méthodes
   */
  Theme.Common.prototype = {
    load: function (className, options) {
      if (Theme[className] !== undefined) {
        return new Theme[className](this, options);
      } else {
        console.error('Class "Theme.' + className + '" not found.');
      }
    },
    autoload: function (options) {
      var self = this;

      if (options !== undefined) {
        $.each(options, function (className, condition) {
          if (self.elements.body.is(condition)) {
            return self.load(className).init();
          }
        });

      } else {
        console.error('Options is undefined.');
      }
    },

    /**
     * Init common
     */
    init: function () {
      this.externalLinksHandler();
      this.openInNewWindowHandler();
      this.anchorLinksHandler();
    },

    /**
     * Gestionnaire des liens externes
     */
    externalLinksHandler: function () {
      if (this.elements.externalLinks.length) {
        this.elements.externalLinks.each(function (i, link) {
          link = $(link);

          if (link.attr('href').indexOf(window.location.host) === -1) {
            link.attr('target', '_blank');
          }
        });
      }
    },

    /**
     * Gestionnaire pour l'ouverture de lien dans un nouvel onglet
     */
    openInNewWindowHandler: function () {
      if (this.elements.openInNewWindowLinks.length) {
        this.elements.openInNewWindowLinks.on('click', function (event) {
          event.preventDefault();
          window.open($(event.currentTarget).attr('href'));
        });
      }
    },

    /**
     * Gestionnaire des ancres
     */
    anchorLinksHandler: function () {
      var self = this;

      self.elements.page.on('click', 'a[href*="#"]:not([href="#"])', function (event) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            event.preventDefault();

            self.scrollTop(target.offset().top);
          }
        }
      });
    },

    /**
     * Scroll top
     *
     * @param offset
     * @param speed
     */
    scrollTop: function (offset, speed) {
      speed = speed || 500;

      this.elements.htmlBody.animate({
        scrollTop: (offset - this.menuScrollOffset)
      }, speed);

      return this;
    },

  };

  /**
   * Load Themes
   * @type {{attach: attach, detach: detach}}
   */
  Drupal.behaviors.drupTheme = {
    attach: function (context) {
      if (context.body !== undefined) {
        Drupal.Theme = new Theme.Common();
        Drupal.Theme.init();
        $(once('drupTheme', context === document ? 'html' : context)).each(function () {
          Drupal.Theme.load('all').init();
        });
        // Drupal.Theme.autoload({
        //     front: '.is-front'
        // });
      }
      // en mode connecté le webform newsletter est créé en ajax -> rappel de la fonction générant le menu
      else if ($(context).hasClass('block-webform-newsletter')) {
        Drupal.Theme = new Theme.Common();
        Drupal.Theme.load('all').initMenuMain();
      }
    }
  };

}(jQuery, Drupal, drupalSettings));

